import { render, staticRenderFns } from "./Comic.vue?vue&type=template&id=bf7c5b5a&"
import script from "./Comic.vue?vue&type=script&lang=js&"
export * from "./Comic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports